import {connect} from 'react-redux';
import EntryCaptainDetail from './EntryCaptainDetail.jsx';
import {handleEntryDetailChangeCaptainClick} from './actions';

const mapStateToProps = state => state.admin.entryDetail.captain;

const mapDispatchToProps = dispatch => ({
  onChangeCaptainClick: () => dispatch(handleEntryDetailChangeCaptainClick())
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryCaptainDetail);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryCaptainDetailContainer.jsx